/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React from 'react';
import PropTypes from 'prop-types';

import { ClickAwayListener, Paper, Typography } from '@material-ui/core';
import useStyles from './styles';

const FilterPanel = ({ onClickAway }) => {
  const classes = useStyles();

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <Paper classes={{ root: classes.filtering }}>
        <Typography>Teste</Typography>
      </Paper>
    </ClickAwayListener>
  );
};

FilterPanel.propTypes = {
  onClickAway: PropTypes.func.isRequired,
};

export default FilterPanel;
